// fontawesome stuffs
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';

/*
  go to node_modules/@fortawesome/XXXXXXX to see available icon names
 */

// 1. import fa icons
// 1.1 regular icons <i class="fa fa-xxx"></i>
import { faCaretDown, faMapPin, faPhoneAlt, faUser, faEnvelope, faClock, faStore, faChevronDown, faCheck, faBars, faChevronUp, faCaretRight, faChevronLeft, faChevronRight, faHome, faMapMarkerAlt, faCheckDouble, faStar, faSearch, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
// 1.2 brand icons <i class="fab fa-xxx"></i>
import { faFacebook, faTwitter, faLinkedin, faInstagram, faGooglePlus  } from '@fortawesome/free-brands-svg-icons';

/*
  for pseudo elements:
      XXX::before {
        display: none;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        font-family: "Font Awesome 5 Solid", serif;
        font-weight: 900;
        content: "\f0d7";
      }
 */
config.searchPseudoElements = true;

// 2. add the imported icons to the library
library.add(
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
  faGooglePlus,


  faCaretDown,
  faHome,
  faMapPin,
  faUser,
  faMapMarkerAlt,
  faPhoneAlt,
  faChevronDown,
  faCheck,
  faBars,
  faChevronUp,
  faCaretRight,
  faChevronLeft,
  faChevronRight,
  faCheckDouble,
  faStar,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faStore,
  faEnvelope,
  faClock
);

dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js